/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-05 10:34:49
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-19 18:28:50
 * @FilePath: \website\src\components\element\attrs\cpt-tree-option.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    cptDataForm: {
        dataText: '{"list":[{"label":"第一段","value":"1","children":[{"label":"第二段","value":"1-1"},{"label":"第二段","value":"1-2"}]},{"label":"第一段","value":"2","children":[{"label":"第二段","value":"2-1"},{"label":"第二段","value":"2-2"}]},{"label":"第一段","value":"3","children":[{"label":"第二段","value":"3-1"},{"label":"第二段","value":"3-2"}]},{"label":"第一段","value":"4","children":[{"label":"第二段","value":"4-1"},{"label":"第二段","value":"4-2"}]}]}',
        dataSource: 1,
        pollTime: 0,
    },
    attribute: {
        fontSize: 16,
        fontColor: '#fff',
        fontLineHeight: 16,
        activable: true,
        activeMultiple: false,
        expandOnClickNode: false,
        checkable: false,
        activableBgColor: 'rgb(36,99,171,1)',
        activableFontColor: '#fff',
        activableFontSize: 16,
        checkableBgColor: '#2684ff',
        backgroundColor: 'transparent',
        checkableColor: '#fff',
        checkableStyle: 'default',
        checkableBgColorAll: '#333333',
        checakableBorderAll: '#6d6d6d',
        checkStrictly: true,
        draggable: false,
        filter: false,
        showIcon: true,
        showLine: false,
        lineColor: '#636363',
        transition: true,
        expandAll: false,
        emptyColor: '#ffffff38',
        emptyFontSize: 16,
        emptyPosition: 'center',
        emptyText: '暂无数据',
        mutex: false,
        isOpenImage: false,
        parentImageUrl: '',
        childrenImageUrl: '',
        initChecked: false,
        mapPoint: false,
        scrollBgColor: 'transparent',
        scrollWidth: 4,
        scrollColor: '#000000',
        isDefault: false,
        isFatherClick: false,
        textFamily: '微软雅黑',
        cptTableData:[
            {"name":"父节点","value":"","namekey":"parent"},
            {"name":"子节点","value":"","namekey":"child"},
            {"name":"显示文本","value":"","namekey":"label"},
            {"name":"值","value":"","namekey":"value"}
        ]
    },
}